/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Tabs, Col, Row, Typography } from 'antd';
import { useState } from 'react';
import ListPhysicalActivities from "./list-physical-activities";
import RegulateLevelPhysicalActivity from "./regulate-level-physical-activity";

export default function ChatGPT() {

  const [activeTab, setActiveTab] = useState("DANH_SACH");

  const items = [
    { key: "DANH_SACH", label: "Danh sách hoạt động thể lực theo cường độ vận động" },
    { key: "QUY_DINH", label: "Quy định mức độ hoạt động thể lực trong công việc" }
  ];

  return (
    <div css={rootStyles}>
      <Row css={boxStyles} justify='space-between' align='middle'>
        <Col>
          <Typography.Title css={titleStyles} level={5}>
            Quản lý hoạt động thể lực
          </Typography.Title>
        </Col>
      </Row>

      <Tabs
        css={tabStyle}
        defaultActiveKey="DANH_SACH"
        onChange={(key) => setActiveTab(key)}
      >
        {items.map((item) => (
          <Tabs.TabPane tab={item.label} key={item.key} />
        ))}
      </Tabs>
      <div>
        {activeTab === "DANH_SACH" && <ListPhysicalActivities />}
        {activeTab === "QUY_DINH" && <RegulateLevelPhysicalActivity />}
      </div>
    </div>
  );
}
const rootStyles = css`
  background: var(--gray-soft-color);
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 1.4rem 2.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const tabStyle = css`
   margin-top: 2rem;
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    padding: 6px 10px;
    color: #333;
    border: 1px solid #ccc;
    background-color: #F0F0F0;
  }

  .ant-tabs-tab-active {
    background-color: var(--blue-dark-color);
    .ant-tabs-tab-btn {
        color: #FFFFFF !important;
    }
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab:hover {
    color: #333 !important;
  }
`;


const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  border-radius: 1rem;
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;
